// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

// material ui
import { Container } from '@mui/material';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Container maxWidth={false}>
      <Outlet />
    </Container>
  );
}
